<!--我的优惠券页面-->
<template>
  <div class="my-coupon app-container" v-loading="doLoading">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!--未使用-->
      <el-tab-pane :label="$t('Unused')" name="first" />
      <!--已使用-->
      <el-tab-pane :label="$t('Used')" name="second" />
      <!--已过期-->
      <el-tab-pane :label="$t('bdPeriod.expiredWeek')" name="third" />
    </el-tabs>
    <Coupons :coupon-list="list" />
  </div>
</template>

<script>
import Coupons from "@/components/Coupons.vue";
import {listByDTO} from "@/api/po/coupon";
export default {
  name: 'MyCoupon',
  directives: {},
  components: {Coupons},
  data() {
    return {
      activeName: 'first',
      list: [],
      doLoading: false,
      total: 0
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {
  },
  created() {
    this.getList(0, 0)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  },
  methods: {
    handleClick() {
      console.log(this.activeName, 'activeName')
      if (this.activeName === 'first') {
        this.getList(0, 0)
      } else if (this.activeName === 'second') {
        this.getList(1)
      } else {
        this.getList(0 , 1)
      }
    },
    getList(status, expired=null) {
      this.doLoading = true
      listByDTO({ status: status, expired: expired }).then(res => {
        this.doLoading = false
        this.list = res.data
        console.log(this.list, 'this.list')
      }).catch(err => {
        console.error(err)
        this.doLoading = false
      })
    },
  }
}

</script>

<style lang="scss" scoped>

</style>
